
jQuery(document).ready(function($) {

    const groupsInput = $('form input.multi-groups');
    if (groupsInput.length) {
        groupsInput.tagsInput({
            placeholder:'Gruppen hinzufügen',
            minChars: 2,
            maxChars: 10,
            limit: 10,
            unique: true,
            autocomplete:{
                autoFocus:true,
                source: groupsInput.data('source'),
                select: function(e, ui){
                    console.log('select', ui.item);
                },
            },
            onAddTag: function(){
                console.log('onAdd', arguments);
            }
        });
    }

});
